/** Internal taproom customers — $0 SO/invoice lines, Tax Free. */

const TAPROOM_NAMES = new Set([
  'obb taproom',
  'obba taproom',
  'obb taproom site',
  'obba taproom site',
  'madison taproom',
  'athens taproom',
]);

export function isTaproomCustomer(customer?: {
  name?: string | null;
  customerType?: string | null;
} | null): boolean {
  if (!customer) return false;
  if (String(customer.customerType || '').trim().toLowerCase() === 'taproom') return true;
  return TAPROOM_NAMES.has(String(customer.name || '').trim().toLowerCase());
}
